import { render } from "./BlogMouthSmell.vue?vue&type=template&id=691be6f8"
import script from "./BlogMouthSmell.vue?vue&type=script&lang=js"
export * from "./BlogMouthSmell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__